export default function Galerie() {
  return (
    <section className="block gallerie">
      <div className="title">
        <h2>Gallerie</h2>
      </div>
    </section>
  );
}